import React from 'react'
import { Modal } from 'antd'
import { useDispatch } from 'react-redux'
import { toggleGenerateSimilarSubmissionsModal } from '../../../../store/slices/assignment.slice'
import GenerateSimilarSubmissionsForm from './GenerateSimilarSubmissionsForm'

const GenerateSimilarSubmissionsModal = () => {
    const dispatch = useDispatch()

    return (
        <Modal
            title='Generate similar submissions'
            open={true}
            footer={null}
            onCancel={() => dispatch(toggleGenerateSimilarSubmissionsModal())}
        >
            <GenerateSimilarSubmissionsForm />
        </Modal>
    )
}

export default GenerateSimilarSubmissionsModal
